<template>
  <div>
    <DataLoader :is_on="main_loading" />
    <div class="case-top-line">
      <div class="case-top-line-left">
        <div v-if="!isInstitucija" class="case-name">
          {{ represented_pers.ime }} {{ represented_pers.prezime }}
        </div>
        <div v-else class="case-name">
          {{ represented_pers.naziv }}
        </div>
        <div v-if="!isLaw" class="edit-case-name add-button add-pen" @click="editOsoba()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            viewBox="0 0 13 13"
          >
            <g>
              <g>
                <path
                  fill="#7b7b8a"
                  d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                />
              </g>
            </g>
          </svg>
        </div>
        <!-- <div @click="deletePerson"> Deletni</div> -->
      </div>
    </div>
    <div class="case-predmet osobe-profile">
      <div class="case-predmet-left">
        <div class="crm-naplata section person-cases-section">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                id="SVGDoc"
                width="52"
                height="52"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:avocode="https://avocode.com/"
                viewBox="0 0 52 52"
              >
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>Rectangle 1</title>
                    <path
                      d="M10.39256,0.39255h31.60739c5.52285,0 9.99999,4.47714 9.99999,9.99999v31.60742c0,5.52285 -4.47714,10.00008 -9.99999,10.00008h-31.60739c-5.52285,0 -9.99999,-4.47723 -9.99999,-10.00008v-31.60742c0,-5.52285 4.47714,-9.99999 9.99999,-9.99999z"
                      fill="#f1f0ff"
                      fill-opacity="1"
                    ></path>
                  </g>
                  <g>
                    <title>slucajevi</title>
                    <path
                      d="M41.2481,27.73258v0.32008c0,1.24517 -0.6901,2.78386 -1.80101,4.01527c-1.26219,1.39922 -2.81906,2.16982 -4.38404,2.16982c-1.56486,0 -3.12185,-0.7706 -4.38404,-2.16982c-1.11091,-1.2314 -1.80089,-2.7701 -1.80089,-4.01527v-0.32008l4.49455,-7.49105l-4.77695,-1.89516c-0.23818,0.23112 -0.5151,0.41941 -0.81646,0.55468v16.43541h2.91193l2.83182,5.66357h-13.79788l2.8317,-5.66357h2.91204v-16.43568c-0.30136,-0.135 -0.57828,-0.3233 -0.81646,-0.5545l-4.77695,1.89516l4.49467,7.49114v0.32008c0,1.24517 -0.6901,2.78386 -1.80101,4.01527c-1.26219,1.39922 -2.81918,2.16982 -4.38404,2.16982c-1.56486,0 -3.12185,-0.7706 -4.38404,-2.16982c-1.11091,-1.2314 -1.80101,-2.7701 -1.80101,-4.01527v-0.32008l5.39565,-8.99273l6.39904,-2.53871c0.04375,-1.07378 0.69749,-2.03231 1.67418,-2.46996v-1.97911h2.3104v1.97911c0.97668,0.43765 1.63054,1.39618 1.67429,2.46996l6.39892,2.53871zM38.61798,29.20779h-7.10988c0.28431,0.59813 0.72646,1.20118 1.23584,1.67415c0.51355,0.47699 1.33276,1.04544 2.3191,1.04544c0.98634,0 1.80566,-0.56845 2.31922,-1.04544c0.50938,-0.47296 0.95153,-1.07601 1.23572,-1.67415zM38.05269,26.89743l-2.98965,-4.98283l-2.98965,4.98283zM29.78481,38.68976l-0.52142,-1.04302h-5.27859l-0.52154,1.04302zM26.10256,16.31629c0,0.28744 0.23401,0.52133 0.52154,0.52133c0.28741,0 0.52142,-0.23389 0.52142,-0.52133c0,-0.28762 -0.23401,-0.52169 -0.52142,-0.52169c-0.28753,0 -0.52154,0.23407 -0.52154,0.52169zM15.86582,30.88194c0.51355,0.47699 1.33288,1.04544 2.31922,1.04544c0.98634,0 1.80554,-0.56845 2.31922,-1.04544c0.50926,-0.47296 0.95141,-1.07601 1.2356,-1.67415h-7.10976c0.28419,0.59813 0.72634,1.20118 1.23572,1.67415zM21.17468,26.89743l-2.98965,-4.98283l-2.98965,4.98283z"
                      fill="#1e33f2"
                      fill-opacity="1"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            Predmeti:
            <div class="generiraj-rocisnik-button" @click="openReport()">
              <span>Izvještaj</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none"><path d="M5.24463 13.7815L8.23776 9.89137L11.652 12.5733L14.581 8.79297" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="17.9954" cy="3.20027" r="1.9222" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle><path d="M12.9243 2.12024H5.65655C2.64511 2.12024 0.777832 4.25296 0.777832 7.2644V15.3468C0.777832 18.3582 2.6085 20.4818 5.65655 20.4818H14.2607C17.2721 20.4818 19.1394 18.3582 19.1394 15.3468V8.30788" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </div>
          </div>
          <!-- <div class="edit-info add-button add-pen">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
            >
              <g>
                <g>
                  <path
                    fill="#7b7b8a"
                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                  />
                </g>
              </g>
            </svg>
          </div> -->
          <div :class="[popis_predmeta.length > 5?'person-cases-wrapper':'', 'person-all-cases']">
            <div
              class="case-info-item"
              v-for="(predmet, key) of finalni_arr_prikaza"
              :key="key"
            >
              <div class="case-info-item-title">
                {{ predmet.predmet.broj_predmeta }}
              </div>
              <div class="case-info-item-info">
                <router-link :to="'/case/' + predmet.predmet.group_url + '/'"
                  >{{ predmet.predmet.ime_predmeta }}
                </router-link>
              </div>
            </div>
          </div>
            <div class="pagin-wrapp page-nav" v-if="all_pages.length > 1">
              <div class="page-nav-prev" v-if="!isFirstPage" @click="setPage(curr_page - 1)">
                <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
                  <defs>
                    <clipPath id="ClipPath1018">
                      <path
                        d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                        fill="#ffffff"></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path class="sssdf"
                          d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                          fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                          stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                          clip-path='url("#ClipPath1018")'></path>
                      </g>
                      <g>
                        <g>
                          <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                            fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                            stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                            stroke-miterlimit="20" stroke-width="2"></path>
                        </g>
                        <g>
                          <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                            fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                            stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                            stroke-width="2"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="page-nav-no">
                <div :class="{ 'curr-page': curr_page == 1 }" @click="setPage(1)">
                  1
                </div>
              </div>
              <div class="page-nav-no" v-if="left_dots_visible">
                <div>
                  ...
                </div>
              </div>
              <div class="page-nav-no" v-for="(str, key) in getLeftRightPages" :key="key" @click="setPage(str)">
                <div :class="{ 'curr-page': curr_page == str }">
                  {{ str }}
                </div>
              </div>
              <div class="page-nav-no" v-if="right_dots_visible">
                <div>
                  ...
                </div>
              </div>
              <div class="page-nav-no" v-if="all_pages.length>1">
              <div :class="{ 'curr-page': curr_page == all_pages.length }"
                @click="setPage(all_pages.length)">
                {{ all_pages.length }}
              </div>
              </div>
              <div class="page-nav-next" v-if="!isLastPage" @click="setPage(curr_page + 1)">
                <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
                  <defs>
                    <clipPath id="ClipPath1043">
                      <path
                        d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                        fill="#ffffff"></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path class="sssdf"
                          d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                          fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                          stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                          clip-path='url("#ClipPath1043")'></path>
                      </g>
                      <g>
                        <g>
                          >
                          <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                            fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                            stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                            stroke-miterlimit="20" stroke-width="2"></path>
                        </g>
                        <g>
                          <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                            fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                            stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                            stroke-width="2"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
        </div>
        <div v-if="!isInstitucija && !isLegBody" class="crm-naplata section person-cases-section">
          <div class="section-title">
            <div class="osobe-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="43" height="42" viewBox="0 0 43 42" fill="none">
              <rect width="43" height="42" rx="10" fill="#F2F2F2"/>
              <path d="M33.99 17.3308L32.717 30.4265C32.6582 31.3075 31.8833 32 30.9527 32H13.0472C12.1625 32 11.4058 31.3382 11.2864 30.4606L11.283 30.4273L10.0099 17.3274C9.96668 17.005 10.0661 16.6732 10.2823 16.4216C10.3974 16.2879 10.5407 16.1806 10.7021 16.1071C10.8636 16.0336 11.0394 15.9957 11.2172 15.996H12.204L11.871 13.863C11.814 13.5236 11.9143 13.1722 12.1495 12.8976C12.383 12.6264 12.7203 12.4712 13.0749 12.4712H14.6688L14.3384 10.3944C14.3107 10.223 14.3213 10.0476 14.3694 9.88054C14.4175 9.71351 14.502 9.55883 14.6169 9.42728C14.8504 9.15607 15.1877 9 15.5423 9H28.4862C28.8408 9 29.1764 9.1501 29.4073 9.41279C29.639 9.67632 29.742 10.0303 29.6909 10.3833L29.3407 12.4694H30.9527C31.3073 12.4694 31.642 12.6195 31.8729 12.8822C32.1047 13.1449 32.2085 13.498 32.1574 13.8511L31.8228 15.9952H32.7827C33.1451 15.9952 33.4858 16.1504 33.7185 16.4216C33.9347 16.6724 34.0333 17.0041 33.99 17.3299V17.3308ZM16.5654 12.4703H27.4415L27.7131 10.8473H16.3076L16.5654 12.4703ZM14.1006 15.996H29.927L30.1891 14.3185H13.8385L14.1006 15.996ZM32.058 17.8433H11.942L13.1389 30.1553L30.8619 30.1527L32.058 17.8433ZM17.5703 22.0846C17.5703 21.5755 17.9906 21.161 18.5078 21.161H25.4922C26.0093 21.161 26.4296 21.5755 26.4296 22.0846C26.4296 22.5938 26.0093 23.0083 25.4922 23.0083H18.5078C18.2593 23.0083 18.021 22.911 17.8452 22.7378C17.6694 22.5646 17.5705 22.3297 17.5703 22.0846V22.0846Z" fill="black"/>
              </svg>          
            </div>
            Projekti:
          </div>
          <div :class="[popis_projekata.length > 5?'person-cases-wrapper':'', 'person-all-cases']">
            <div
              class="case-info-item"
              v-for="(projekt, key) of finalni_arr_prikaza_proj"
              :key="key"
            >
              <div class="case-info-item-title">
                {{ projekt.project.broj_projekta }}
              </div>
              <div class="case-info-item-info">
                <router-link :to="'/projects/' + projekt.project.group_url + '/'"
                  >{{ projekt.project.name }}
                </router-link>
              </div>
            </div>
          </div>
            <div class="pagin-wrapp page-nav" v-if="all_pages_proj.length > 1">
              <div class="page-nav-prev" v-if="!isFirstPageProj" @click="setPageProj(curr_page_proj - 1)">
                <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
                  <defs>
                    <clipPath id="ClipPath1018">
                      <path
                        d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                        fill="#ffffff"></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path class="sssdf"
                          d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                          fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                          stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                          clip-path='url("#ClipPath1018")'></path>
                      </g>
                      <g>
                        <g>
                          <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                            fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                            stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                            stroke-miterlimit="20" stroke-width="2"></path>
                        </g>
                        <g>
                          <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                            fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                            stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                            stroke-width="2"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="page-nav-no">
                <div :class="{ 'curr-page': curr_page_proj == 1 }" @click="setPageProj(1)">
                  1
                </div>
              </div>
              <div class="page-nav-no" v-if="left_dots_visible_proj">
                <div>
                  ...
                </div>
              </div>
              <div class="page-nav-no" v-for="(str, key) in getLeftRightPagesProj" :key="key" @click="setPageProj(str)">
                <div :class="{ 'curr-page': curr_page_proj == str }">
                  {{ str }}
                </div>
              </div>
              <div class="page-nav-no" v-if="right_dots_visible_proj">
                <div>
                  ...
                </div>
              </div>
              <div class="page-nav-no" v-if="all_pages_proj.length>1">
              <div :class="{ 'curr-page': curr_page_proj == all_pages_proj.length }"
                @click="setPageProj(all_pages_proj.length)">
                {{ all_pages_proj.length }}
              </div>
              </div>
              <div class="page-nav-next" v-if="!isLastPageProj" @click="setPageProj(curr_page_proj + 1)">
                <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
                  <defs>
                    <clipPath id="ClipPath1043">
                      <path
                        d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                        fill="#ffffff"></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path class="sssdf"
                          d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                          fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                          stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                          clip-path='url("#ClipPath1043")'></path>
                      </g>
                      <g>
                        <g>
                          >
                          <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                            fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                            stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                            stroke-miterlimit="20" stroke-width="2"></path>
                        </g>
                        <g>
                          <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                            fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                            stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                            stroke-width="2"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
        </div>
        <div class="crm-komunikacija section" v-if="visible_comunication">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                id="SVGDoc"
                width="52"
                height="52"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:avocode="https://avocode.com/"
                viewBox="0 0 52 52"
              >
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>Rectangle 1</title>
                    <path
                      d="M10.39256,0.39256h31.60739c5.52285,0 9.99999,4.47714 9.99999,9.99999v31.60742c0,5.52285 -4.47714,9.99999 -9.99999,9.99999h-31.60739c-5.52285,0 -9.99999,-4.47714 -9.99999,-9.99999v-31.60742c0,-5.52285 4.47714,-9.99999 9.99999,-9.99999z"
                      fill="#fef2e2"
                      fill-opacity="1"
                    ></path>
                  </g>
                  <g>
                    <title>Shape 545</title>
                    <path
                      d="M39.59622,18.21092v15.46875c0,1.28245 -1.05345,2.32038 -2.33757,2.32038h-21.92104c-1.29199,0 -2.33757,-1.0457 -2.33757,-2.32038v-15.46875c0,-1.27888 1.05023,-2.32029 2.33757,-2.32029h21.92104c1.29199,0 2.33757,1.0457 2.33757,2.32029zM15.66793,17.43755l10.67972,10.51006l10.58829,-10.51006zM22.06339,25.90966l-7.50506,-7.38573v14.83548zM36.93594,34.45312l-7.46918,-7.41398l-2.56574,2.54676c-0.30339,0.30121 -0.79489,0.3022 -1.09947,0.00241l-2.63143,-2.58958l-7.50983,7.4544zM38.03791,18.53126l-7.46918,7.41407l7.46918,7.41398z"
                      fill="#fe9923"
                      fill-opacity="1"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            Komunikacija
          </div>
          <!-- <div class="add-zadatak add-button add-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <g>
                <g>
                  <path
                    fill="#0acab1"
                    d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
                  />
                </g>
              </g>
            </svg>
          </div> -->
          <div class="case-info-item" v-if="loading_flag">
            <div class="center-spinner">
              <svg class="dot-spin" viewBox="0 0 50 50">
                  <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
              </svg>
            </div>
          </div>
          <div v-if="!loading_flag && finalni_arr_prikaza_kom.length == 0" class="case-info-item">
            <span>{{ comunication_text_handle }}</span>   
          </div>

            <div
              class="case-info-item  communication-element"
              v-for="(com, key) in finalni_arr_prikaza_kom"
              :key="key"
              @click="openFile(com.webUrl)"
            >
              <div class="case-info-item-title">
                {{ switchDate(com.lastModifiedDateTime) }}
              </div>
              <div class="case-info-item-info">
                <div class="prilog-mail">
                  <span class="prilog-mail-title">{{ com.name }}</span>
                </div>
                <div class="prilog-details-wrapper">
                  <div class="prilog-details">
                    Upload: <span>{{ com.createdBy.user.displayName }}</span>
                  </div>
                  <div class="prilog-details">
                    Predmet: <span>{{ com.predmet }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="pagin-wrapp page-nav" v-if="all_pages_kom.length > 1">
              <div class="page-nav-prev" v-if="!isFirstPageKom" @click="setPageKom(curr_page_kom - 1)">
                <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
                  <defs>
                    <clipPath id="ClipPath1018">
                      <path
                        d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                        fill="#ffffff"></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path class="sssdf"
                          d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                          fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                          stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                          clip-path='url("#ClipPath1018")'></path>
                      </g>
                      <g>
                        <g>
                          <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                            fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                            stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                            stroke-miterlimit="20" stroke-width="2"></path>
                        </g>
                        <g>
                          <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                            fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                            stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                            stroke-width="2"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="page-nav-no">
                <div :class="{ 'curr-page': curr_page_kom == 1 }" @click="setPageKom(1)">
                  1
                </div>
              </div>
              <div class="page-nav-no" v-if="left_dots_visible_kom">
                <div>
                  ...
                </div>
              </div>
              <div class="page-nav-no" v-for="(str, key) in getLeftRightPagesKom" :key="key" @click="setPageKom(str)">
                <div :class="{ 'curr-page': curr_page_kom == str }">
                  {{ str }}
                </div>
              </div>
              <div class="page-nav-no" v-if="right_dots_visible_kom">
                <div>
                  ...
                </div>
              </div>
              <div class="page-nav-no" v-if="all_pages_kom.length>1">
              <div :class="{ 'curr-page': curr_page_kom == all_pages_kom.length }"
                @click="setPageKom(all_pages_kom.length)">
                {{ all_pages_kom.length }}
              </div>
              </div>
              <div class="page-nav-next" v-if="!isLastPageKom" @click="setPageKom(curr_page_kom + 1)">
                <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
                  <defs>
                    <clipPath id="ClipPath1043">
                      <path
                        d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                        fill="#ffffff"></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path class="sssdf"
                          d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                          fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                          stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                          clip-path='url("#ClipPath1043")'></path>
                      </g>
                      <g>
                        <g>
                          >
                          <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                            fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                            stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                            stroke-miterlimit="20" stroke-width="2"></path>
                        </g>
                        <g>
                          <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                            fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                            stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                            stroke-width="2"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>  

          <!-- <div class="case-info-item">
            <div class="case-info-item-title">18.03.2021.</div>
            <div class="case-info-item-info">
              Klijent traži sastanak vezan uz spor sa norveškim kooperantom 
              <span class="komunikacija-autor">Marko Porobija</span>
              <div class="prilog-mail"><span class="prilog-mail-title">E-mail</span><a href="#">Potpis ugovora u poslovnoj suradnji 11.03.2021. Sent from: Martina Lončarić...</a></div>
            </div>
          </div>
          <div class="case-info-item">
            <div class="case-info-item-title">12.03.2021.</div>
            <div class="case-info-item-info">
              Ugovor o poslovnoj suradnji odobren, finaliziran i potpisan. Ugovor unesen u ERP.
              <span class="komunikacija-autor">Dubravka Črnila</span>
            </div>
          </div>
          <div class="case-info-item">
            <div class="case-info-item-title">07.03.2021.</div>
            <div class="case-info-item-info">
              Predugovor odobren, finaliziran i potpisan, Dalekovod oformljen kao klijent, slijedi izrada ugovora u poslovnoj suradnji
              <span class="komunikacija-autor">Dubravka Črnila</span>
              <div class="komunikacija-zadatak">unesen zadatak</div>
            </div>
          </div>
          <div class="case-info-item">
            <div class="case-info-item-title">02.03.2021.</div>
            <div class="case-info-item-info">
              Dalekovod je kontaktiran i uspostavljen je kontakt sa članicom uprave Martinom Lončarić Levanić, poslati prijedlog predugovora o uspostavi poslovne suradnje
              <span class="komunikacija-autor">Suzana Cesarec</span>
              <div class="prilog-mail"><span class="prilog-mail-title">E-mail</span><a href="#">Problem sa Elevio AB.18.3.2021. Sent from: Igor Viduka</a></div>
            </div>
          </div>
          <div class="case-info-item">
            <div class="case-info-item-title">02.03.2021.</div>
            <div class="case-info-item-info">
              Dalekovod kao potencijalni klijent preporučen od strane Infrastruktura d.o.o. (gospođa Cindrić) – vezano uz spor oko izgradnje dalekovoda u Norveškoj 
              <span class="komunikacija-autor">Suzana Cesarec</span>
              <div class="prilog-mail"><span class="prilog-mail-title">E-mail</span><a href="#">Možda novi klijent za vas? 30.01.2021. Sent from: Ivana Cindrić</a></div>
            </div>
          </div> -->
        </div>
        <!-- Close crm-komunikacija  -->
      </div>
      <!-- Close case-predmet-left -->
      <div class="case-predmet-right">
        <div class="crm-info section osobe-profile-info">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                id="SVGDoc"
                width="52"
                height="52"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:avocode="https://avocode.com/"
                viewBox="0 0 52 52"
              >
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>Rectangle 1</title>
                    <path
                      d="M10.39255,0.39254h31.60751c5.52273,0 9.99999,4.47723 9.99999,10.00008v31.60742c0,5.52285 -4.47726,9.99999 -9.99999,9.99999h-31.60751c-5.52285,0 -9.99999,-4.47714 -9.99999,-9.99999v-31.60742c0,-5.52285 4.47714,-10.00008 9.99999,-10.00008z"
                      fill="#feedf3"
                      fill-opacity="1"
                    ></path>
                  </g>
                  <g>
                    <title>Shape 546</title>
                    <path
                      d="M39.00004,21.41668v10.23996c0,4.43539 -2.8547,7.41667 -7.10595,7.41667h-10.86664c-4.24743,0 -7.10082,-2.98128 -7.10082,-7.41667v-10.23996c0,-4.43548 2.85339,-7.41667 7.10082,-7.41667h10.86915c4.24874,0 7.10344,2.98119 7.10344,7.41667zM37.11951,21.41668c0,-3.36358 -2.051,-5.53617 -5.22292,-5.53617h-10.86915c-3.17049,0 -5.22029,2.17259 -5.22029,5.53617v10.23996c0,3.36358 2.0498,5.53617 5.22029,5.53617h10.86664c3.17442,0 5.22542,-2.17259 5.22542,-5.53617zM27.39597,26.53666v5.01466c0,0.51901 -0.42129,0.94029 -0.94032,0.94029c-0.5188,0 -0.9402,-0.42129 -0.9402,-0.94029v-5.01466c0,-0.51901 0.4214,-0.9402 0.9402,-0.9402c0.51904,0 0.94032,0.4212 0.94032,0.9402zM27.71569,21.77788c0,0.69326 -0.56052,1.25366 -1.25372,1.25366c-0.69344,0 -1.25992,-0.5604 -1.25992,-1.25366c0,-0.69326 0.5554,-1.25366 1.24741,-1.25366h0.01252c0.6932,0 1.25372,0.5604 1.25372,1.25366z"
                      fill="#fd4087"
                      fill-opacity="1"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            Info
          </div>
          <div class="crm-info-part">
            <div v-if="!isLegBody" class="case-info-item">
              <div class="case-info-item-title">OIB:</div>
              <div class="case-info-item-info">
                {{ represented_pers.oib }}
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Uloga:</div>
              <div class="case-info-item-info">
                {{ represented_pers.uloga }}
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Datum upisa:</div>
              <div
                class="case-info-item-info"
                v-if="represented_pers.datum_unosa != null"
              >
                {{ switchDate(represented_pers.datum_unosa) }}
              </div>
            </div>
            <div class="case-info-item" v-if="isFizicka">
              <div class="case-info-item-title">Datum rođenja:</div>
              <div
                class="case-info-item-info"
                v-if="represented_pers.rodjendan != null"
              >
                {{ switchDate(represented_pers.rodjendan) }}
              </div>
            </div>
          </div>
          <div v-if="!isInstitucija && !isLaw" class="crm-info-part">
            <div v-if="!isLegBody" class="case-info-item">
              <div class="case-info-item-title">Industrija:</div>
              <div class="case-info-item-info">
                {{
                  represented_pers.industrija_id.naziv[0].toUpperCase() +
                  represented_pers.industrija_id.naziv.slice(1)
                }}
              </div>
            </div>
            <div v-if="!isLegBody" class="case-info-item">
              <div class="case-info-item-title">Godišnji prihod:</div>
              <div class="case-info-item-info">
                {{ represented_pers.god_prihod }}
              </div>
            </div>
            <div class="case-info-item" v-if="isLegBody">
              <div class="case-info-item-title">Nadležna institucija:</div>
              <div
                class="case-info-item-info"
                v-if="represented_pers.institucija"
              >
                <router-link
                  :to="'/osobe/institucije/' + represented_pers.institucija.uid"
                  >{{ represented_pers.institucija.naziv }}</router-link
                >
              </div>
            </div>
          </div>
          <div class="crm-info-part">
            <div class="case-info-item">
              <div class="case-info-item-title">E-mailovi:</div>
              <div class="case-info-item-info">
                <div
                  v-for="(singleMail, key) in represented_pers.email_list"
                  :key="key"
                >
                  {{ singleMail }}
                </div>
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Telefoni:</div>
              <div class="case-info-item-info">
                <div
                  v-for="(singleTel, key) in represented_pers.tel_br_list"
                  :key="key"
                >
                  {{ singleTel }}
                </div>
              </div>
            </div>

            <div class="case-info-item">
              <div class="case-info-item-title">Adrese:</div>
              <div class="case-info-item-info">
                <div
                  v-for="(singleAdd, key) in represented_pers.adresa"
                  :key="key"
                >
                  {{ singleAdd.adresa + ", " }}{{ singleAdd.post_br + ", "
                  }}{{ singleAdd.grad + ", " }}{{ singleAdd.drzava }}
                </div>
              </div>
            </div>

            <div class="case-info-item">
              <div class="case-info-item-title">Web stranice:</div>
              <div class="case-info-item-info">
                <div
                  v-for="(stranica, key) in represented_pers.web_list"
                  :key="key"
                >
                  {{ stranica }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isInstitucija" class="crm-info-part">
            <div v-if="!isLegBody && !isLaw" class="case-info-item">
              <div class="case-info-item-title">Tip izvora:</div>
              <div class="case-info-item-info">
                {{ represented_pers.id_tip_izvora.naziv }}
              </div>
            </div>
            <div v-if="!isLegBody && !isLaw" class="case-info-item">
              <div
                class="case-info-item-title"
                v-if="represented_pers.id_tip_izvora.id_tip_izvora != 5"
              >
                Izvor:
              </div>
              <div class="case-info-item-info">
                {{ getCorrectName() }}
              </div>
            </div>
            <div class="case-info-item">
              <div class="case-info-item-title">Upisan od:</div>
              <div
                class="case-info-item-info"
                v-if="represented_pers.upisan_od"
              >
                <router-link
                  :to="'/osobe/law/' + represented_pers.upisan_od.uid"
                  >{{ represented_pers.upisan_od.ime }}
                  {{ represented_pers.upisan_od.prezime }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <div class="crm-naplata section" v-if="visible_work">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                id="SVGDoc"
                width="52"
                height="52"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:avocode="https://avocode.com/"
                viewBox="0 0 52 52"
              >
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>Rectangle 1</title>
                    <path
                      d="M10.39255,0.39259h31.60751c5.52273,0 9.99999,4.47714 9.99999,9.99999v31.60742c0,5.52285 -4.47726,9.99999 -9.99999,9.99999h-31.60751c-5.52285,0 -9.99999,-4.47714 -9.99999,-9.99999v-31.60742c0,-5.52285 4.47714,-9.99999 9.99999,-9.99999z"
                      fill="#e2fefa"
                      fill-opacity="1"
                    ></path>
                  </g>
                  <g>
                    <title>Shape 547</title>
                    <path
                      d="M38.41114,25.79445c0,6.7302 -5.47528,12.20557 -12.2056,12.20557c-6.7302,0 -12.2056,-5.47528 -12.2056,-12.20557c0,-6.73029 5.4754,-12.20557 12.2056,-12.20557c6.73032,0 12.2056,5.47528 12.2056,12.20557zM35.74324,25.79445c0,-5.25901 -4.27842,-9.53776 -9.5377,-9.53776c-5.25916,0 -9.5377,4.27875 -9.5377,9.53776c0,5.25919 4.27854,9.53767 9.5377,9.53767c5.25928,0 9.5377,-4.27848 9.5377,-9.53767zM30.81036,29.35714c0.40388,0.40367 0.40364,1.0584 0,1.46234c-0.40364,0.40394 -1.05834,0.40394 -1.46222,0l-3.85118,-3.85085c-0.2147,-0.21476 -0.31161,-0.50023 -0.29802,-0.78142c-0.00072,-0.01627 -0.00477,-0.03156 -0.00477,-0.04783v-5.44596c0,-0.57122 0.46289,-1.03408 1.03402,-1.03408c0.57101,0 1.0339,0.46286 1.0339,1.03408v5.1156z"
                      fill="#0acab1"
                      fill-opacity="1"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            Radno vrijeme:
          </div>
          <!-- <div class="edit-info add-button add-pen">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
            >
              <g>
                <g>
                  <path
                    fill="#7b7b8a"
                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                  />
                </g>
              </g>
            </svg>
          </div> -->
          <div class="case-info-item radno-vrijeme-item">
            <!-- <div class="case-info-item-title">Pon-pet</div> -->
            <div class="case-info-item-info">
              {{ represented_pers.radno_vrijeme }}
            </div>
          </div>
          <!-- <div class="case-info-item radno-vrijeme-item">
            <div class="case-info-item-title">Za stranke</div>
            <div class="case-info-item-info">08:00 - 16:00</div>
          </div> -->
        </div>
        <div class="crm-opis section">
          <div class="section-title">
            <div class="osobe-icon">
              <svg
                id="SVGDoc"
                width="52"
                height="52"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xmlns:avocode="https://avocode.com/"
                viewBox="0 0 52 52"
              >
                <defs></defs>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <title>Rectangle 1</title>
                    <path
                      d="M10.39255,0.39257h31.60751c5.52273,0 9.99999,4.47714 9.99999,9.99999v31.60742c0,5.52285 -4.47726,9.99999 -9.99999,9.99999h-31.60751c-5.52285,0 -9.99999,-4.47714 -9.99999,-9.99999v-31.60742c0,-5.52285 4.47714,-9.99999 9.99999,-9.99999z"
                      fill="#faeafd"
                      fill-opacity="1"
                    ></path>
                  </g>
                  <g>
                    <title>Shape 548</title>
                    <path
                      d="M25.88714,40.99997c-1.53363,0 -2.63083,-1.15326 -3.50976,-2.07594c-0.37408,-0.45446 -0.82111,-0.84409 -1.32167,-1.15326c-0.61095,-0.15208 -1.24311,-0.20072 -1.87027,-0.14341c-1.32167,0 -2.81155,0.04989 -3.85892,-0.99126c-1.04737,-1.04105 -0.98503,-2.53102 -0.95999,-3.85264c0.05853,-0.62719 0.01001,-1.2593 -0.14341,-1.8703c-0.30923,-0.5005 -0.6988,-0.94754 -1.15335,-1.32161c-0.89777,-0.84785 -2.06971,-1.94505 -2.06971,-3.47874c0,-1.5336 1.17195,-2.6308 2.06971,-3.50976c0.45443,-0.37408 0.844,-0.82111 1.15335,-1.3217c0.1533,-0.61092 0.20194,-1.24303 0.14341,-1.87021c0,-1.31544 -0.04995,-2.81158 0.99123,-3.85273c1.04105,-1.04105 2.53725,-1.01611 3.85892,-0.99117c0.62716,0.05856 1.25921,0.01055 1.87016,-0.14341c0.50068,-0.30917 0.947,-0.6988 1.32167,-1.15326c0.84782,-0.87288 1.94502,-2.04492 3.47865,-2.04492c1.53363,0 2.63083,1.17204 3.50988,2.07603c0.37396,0.45446 0.82099,0.84409 1.32155,1.15326c0.61095,0.15333 1.24311,0.20197 1.87027,0.14341c1.32167,0 2.81155,-0.04989 3.85892,0.99117c1.04737,1.04114 1.01614,2.53728 0.99123,3.85273c-0.05865,0.62719 -0.01001,1.2593 0.14341,1.87021c0.30923,0.50059 0.6988,0.94762 1.15323,1.3217c0.86665,0.84785 2.03872,1.94505 2.03872,3.47865c0,1.53369 -1.17207,2.63089 -2.06983,3.50985c-0.45443,0.37408 -0.844,0.82111 -1.15323,1.32161c-0.1533,0.61101 -0.20194,1.24311 -0.14341,1.8703c0,1.31544 0.04995,2.81158 -0.99123,3.85264c-1.04105,1.04114 -2.53725,1.0162 -3.85892,0.99126c-0.62716,-0.05919 -1.25933,-0.01055 -1.87027,0.14341c-0.50056,0.30917 -0.94688,0.6988 -1.32155,1.15326c-0.84794,0.87288 -1.94514,2.04483 -3.47877,2.04483zM19.79018,35.04636c0.76556,-0.03487 1.53041,0.08163 2.25055,0.34288c0.84472,0.42647 1.59156,1.02299 2.1944,1.75184c0.54228,0.5672 1.24681,1.27798 1.6458,1.27798c0.39899,0 1.1034,-0.7107 1.6458,-1.27798c0.60284,-0.72885 1.34969,-1.32537 2.1944,-1.75184c0.92447,-0.30801 1.9033,-0.42209 2.8739,-0.33662c0.72312,0 1.72067,0 1.98865,-0.23693c0.2681,-0.23693 0.24939,-1.24687 0.23699,-1.98877c-0.08547,-0.9706 0.02861,-1.94934 0.33665,-2.8739c0.42641,-0.84472 1.02305,-1.59153 1.75178,-2.1944c0.56732,-0.54234 1.27804,-1.24687 1.27804,-1.6458c0,-0.39902 -0.71073,-1.10346 -1.27804,-1.6458c-0.72873,-0.60278 -1.32537,-1.34969 -1.75178,-2.1944c-0.30804,-0.92456 -0.42272,-1.9033 -0.33665,-2.8739c0,-0.72321 0,-1.72064 -0.23699,-1.98877c-0.23687,-0.26804 -1.24681,-0.25553 -1.98865,-0.23684c-0.9706,0.08538 -1.94883,-0.02933 -2.8739,-0.33671c-0.84472,-0.42638 -1.59156,-1.02299 -2.1944,-1.75175c-0.5424,-0.56729 -1.24693,-1.27807 -1.6458,-1.27807c-0.39899,0 -1.10352,0.7107 -1.6458,1.27807c-0.60296,0.72876 -1.34969,1.32537 -2.1944,1.75175c-0.92518,0.30738 -1.9033,0.42209 -2.87402,0.33671c-0.72312,0 -1.72055,0 -1.98865,0.23684c-0.2681,0.23693 -0.24939,1.24687 -0.23687,1.98877c0.08535,0.9706 -0.02873,1.94934 -0.33665,2.8739c-0.42653,0.84472 -1.02305,1.59162 -1.7519,2.1944c-0.5672,0.54243 -1.27804,1.24687 -1.27804,1.6458c0,0.39902 0.71073,1.10346 1.27804,1.6458c0.72885,0.60287 1.32537,1.34969 1.7519,2.1944c0.30792,0.92456 0.4226,1.9033 0.33665,2.8739c0,0.72321 0,1.72064 0.23687,1.98877c0.23687,0.26804 1.24681,0.24936 1.98865,0.23693z"
                      fill="#a131d0"
                      fill-opacity="1"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            Opis
          </div>
          <p>{{ represented_pers.opis }}</p>
        </div>
      </div>
      <!-- Close case-predmet-right -->
    </div>
    <!-- Close case-predmet -->
    <div v-if="urediFiz">
      <cu-fizicka
        v-if="isFizicka"
        :fizicka_osoba="edit_pers"
        :isNew="false"
      ></cu-fizicka>
      <cu-pravna
        v-if="isPravna"
        :fizicka_osoba="edit_pers"
        :isNew="false"
      ></cu-pravna
      >>
    </div>
  </div>
</template>

<script>
import auth from "@/services/auth";
import GroupList from "@/components/generalComponents/GroupList";
import Opis from "@/components/caseComponents/Opis.vue";
import Kalendar from "@/components/caseComponents/Kalendar.vue";
import Zadaci from "@/components/caseComponents/Zadaci.vue";
import Financije from "@/components/caseComponents/Financije.vue";
import Spisi from "@/components/caseComponents/Spisi.vue";
import osoba from "@/apiCallers/promise_handler_db/osobe_pr";
import CuFizicka from "@/components/personComponents/createUpdateSudionici/CUFizicka.vue";
import CuPravna from "@/components/personComponents/createUpdateSudionici/CUPravna.vue";
import institucije from "@/apiCallers/promise_handler_db/institucije";
import moment from "moment";
import DataLoader from '@/components/generalComponents/DataLoader'

export default {
  components: {
    GroupList,
    Opis,
    Kalendar,
    Zadaci,
    Financije,
    Spisi,
    CuFizicka,
    CuPravna,
    DataLoader
  },
  data() {
    return {
      urediFiz: false,
      accessToken: "",
      represented_pers: {},
      all_comm:[],
      edit_pers: undefined,
      popis_predmeta: [],
      popis_projekata: [],
      visible_work: true,
      visible_comunication: true,
      isFizicka: false,
      isPravna: false,
      isInstitucija: false,
      isLegBody: false,
      isLaw: false,
      komunikacija: [],
      comunication_text_handle: "Trenutno nema komunikacije",
      loading_flag : true,
      curr_page: 1,
      br_redova: 5,
      br_redova_kom:4,
      curr_page_proj: 1,
      all_pages: [],
      all_pages_proj: [],
      finalni_arr_prikaza: [],
      finalni_arr_prikaza_proj: [],
      main_loading:true,
      left_dots_visible:false,
      right_dots_visible:false,
      left_dots_visible_kom:false,
      right_dots_visible_kom:false,
      left_dots_visible_proj:false,
      right_dots_visible_proj:false,
      curr_page_kom: 1,
      all_pages_kom: [],
      finalni_arr_prikaza_kom: [],
    };
  },
  computed:{
    isFirstPage() {
      return this.curr_page == 1;
    },
    isLastPage() {
      return this.curr_page == this.all_pages[this.all_pages.length - 1];
    },
    isFirstPageKom() {
      return this.curr_page_kom == 1;
    },
    isLastPageKom() {
      return this.curr_page_kom == this.all_pages_kom[this.all_pages_kom.length - 1];
    },
    isFirstPageProj() {
      return this.curr_page_proj == 1;
    },
    isLastPageProj() {
      return this.curr_page_proj == this.all_pages_proj[this.all_pages_proj.length - 1];
    },
    getLeftRightPages() {
      // Init values
      let return_pages = []
      this.right_dots_visible = false;
      this.left_dots_visible = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page;
      if(this.curr_page == this.all_pages.length)
        left_end = this.curr_page-1;
      if (this.curr_page > 3) {
        left_start = this.curr_page - 1;
        this.left_dots_visible = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page + 1;
      if (right_start < this.all_pages.length)
        return_pages.push(right_start);
      if(right_start < this.all_pages.length-1)
      this.right_dots_visible = true;
      return return_pages
    },
    getLeftRightPagesKom() {
      // Init values
      let return_pages = []
      this.right_dots_visible_kom = false;
      this.left_dots_visible_kom = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page_kom;
      if(this.curr_page_kom == this.all_pages_kom.length)
        left_end = this.curr_page_kom-1;
      if (this.curr_page_kom > 3) {
        left_start = this.curr_page_kom - 1;
        this.left_dots_visible_kom = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page_kom + 1;
      if (right_start < this.all_pages_kom.length)
        return_pages.push(right_start);
      if(right_start < this.all_pages_kom.length-1)
      this.right_dots_visible_kom = true;
      return return_pages
    },
    getLeftRightPagesProj() {
      // Init values
      let return_pages = []
      this.right_dots_visible_proj = false;
      this.left_dots_visible_proj = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page_proj;
      if(this.curr_page_proj == this.all_pages_proj.length)
        left_end = this.curr_page_proj-1;
      if (this.curr_page_proj > 3) {
        left_start = this.curr_page_proj - 1;
        this.left_dots_visible_proj = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page_proj + 1;
      if (right_start < this.all_pages_proj.length)
        return_pages.push(right_start);
      if(right_start < this.all_pages_proj.length-1)
      this.right_dots_visible_proj = true;
      return return_pages
    },
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);

    var uid = this.$route.fullPath.split("/")[3];
    this.$store.state.paginacija.back_link = '/osobe'
    switch (this.$route.fullPath.split("/")[2]) {
      case "fiz":
        this.isFizicka = true;
        //ovo treba razdvojiti
        osoba.getSingleStrankaProtustranka(uid).then((response) => {
          this.main_loading = false;

          this.represented_pers = response.data;
          this.popis_predmeta = response.data.predmeti;
          this.popis_projekata = response.data.projekti;
          this.calculatePageNumber();
          this.paginirajOdabrane();
          this.calculatePageNumberProj();
          this.paginirajOdabraneProj()
          this.edit_pers = response.data;
          this.$store.state.paginacija.title = "Fizička osoba";
          this.$store.state.paginacija.subpages = [ this.represented_pers.ime +' '+this.represented_pers.prezime];
        });
        osoba.getPhisPersCommunication(uid).then((response) => {
          this.komunikacija = response.data;
          this.calculatePageNumberKom();
          this.paginirajOdabraneKom()
          this.loading_flag = false;
        });
        break;
      case "law":
        this.isLaw = true;
        osoba.getOdvjetnik(uid).then((response) => {
          this.main_loading = false;
          this.represented_pers = response.data;
          this.popis_predmeta = response.data.predmeti;
          this.popis_projekata = response.data.projekti;
          console.log(response.data);
          this.calculatePageNumber();
          this.paginirajOdabrane()
          this.calculatePageNumberProj();
          this.paginirajOdabraneProj()
          this.$store.state.paginacija.title = "Član tima";
          this.$store.state.paginacija.subpages = [ this.represented_pers.ime +' '+this.represented_pers.prezime];          
        });
        osoba.getOdvjetnikComunication(uid).then((response) => {
          this.komunikacija = response.data;
          this.calculatePageNumberKom();
          this.paginirajOdabraneKom()
          this.loading_flag = false;
        });
        break;

      case "leg-body":
        this.isLegBody = true;
        osoba.get_single_legal_body(uid).then((response) => {
          this.main_loading = false;
          this.represented_pers = response.data;
          this.popis_predmeta = response.data.predmeti
          this.calculatePageNumber();
          this.paginirajOdabrane()
          console.log(response.data);
          this.$store.state.paginacija.title = "Sudionik";
          this.$store.state.paginacija.subpages = [ this.represented_pers.ime +' '+this.represented_pers.prezime];
        });
        osoba.getLegBodyComunication(uid).then((response) => {
          this.main_loading = false;
          console.log(response);
          this.komunikacija = response.data.komunikacija;
          this.calculatePageNumberKom();
          this.paginirajOdabraneKom()
          this.loading_flag = false;
        });
        break;
      case "institucije":
        this.isInstitucija = true;
        institucije.getSingleInstitucija(uid).then((response) => {
          this.main_loading = false;
          this.represented_pers = response.data;
          this.popis_predmeta = response.data.predmeti;
          this.calculatePageNumber();
          this.paginirajOdabrane()
          this.$store.state.paginacija.title = "Institucija";
          this.$store.state.paginacija.subpages = [this.represented_pers.naziv];
        });
        institucije.getSingleInstitucijaComunication(uid).then((response) => {
          this.komunikacija = response.data;
          this.loading_flag = false;
          this.calculatePageNumberKom();
          this.paginirajOdabraneKom()
        });
        break;
      case "prav":
        //ovo treba razdvojiti
        this.isPravna = true;        
        osoba.getPravna(uid).then((response) => {
          this.main_loading = false;
          this.represented_pers = response.data;
          this.popis_predmeta = response.data.predmeti;
          this.popis_projekata = response.data.projekti;
          console.log(this.represented_pers);
          this.calculatePageNumber();
          this.paginirajOdabrane();
          this.calculatePageNumberProj();
          this.paginirajOdabraneProj()
          this.edit_pers = response.data;
          this.$store.state.paginacija.title = "Pravna osoba";
          this.$store.state.paginacija.subpages = [this.represented_pers.ime];
        });
        osoba.getPravnaComunication(uid).then((response) => {
          this.komunikacija = response.data;
          this.calculatePageNumberKom();
          this.paginirajOdabraneKom()
          this.loading_flag = false;
        });
        break;

      default:
        break;
    }

    document.body.classList.add("osobe-profil");
    // console.log(this.accessToken)
  },
  watch: {
    accessToken: function () {
      if (this.accessToken) {
      }
    },
    curr_page: function () {
      this.paginirajOdabrane();
    },
    curr_page_kom: function () {
      this.paginirajOdabraneKom();
    },
    curr_page_proj: function () {
      this.paginirajOdabraneProj();
    },
  },
  methods: {
    // async deletePerson(){
    //   if (this.isFizicka) {
    //     await osoba.deleteFizicka(this.$route.params.oib).then((resp)=>{
    //       this.$router.push("/osobe")
    //     })
    //   }
    //   else if(this.isPravna){
    //     await osoba.deletePravna(this.$route.params.oib).then((resp)=>{
    //       this.$router.push("/osobe")
    //     })
    //   }
    //   else if(this.isLegBody){
    //     await osoba.deleteSluzbena(this.$route.params.oib).then((resp)=>{
    //       this.$router.push("/osobe")
    //     })
    //   }
    //   else if(this.isInstitucija){
    //     await institucije.deleteInstitucija(this.$route.params.oib).then((resp)=>{
    //       this.$router.push("/institucije")
    //     })
    //   }
    // },
    async openReport(){
      this.$store.state.predmeti_report_data.all_predmeti = this.popis_predmeta.map((p)=>p.predmet);
      if (this.isLaw) {
        this.$store.state.predmeti_report_data.naslov = `Pregled predmeta odvjetnika ${this.represented_pers.ime} ${this.represented_pers.prezime}`;
        this.$store.state.predmeti_report_data.odvjetnik_name = `${this.represented_pers.ime} ${this.represented_pers.prezime}`;
        this.$store.state.predmeti_report_data.odvjetnik_nositelj = this.$route.fullPath.split("/")[3];
      }
      else if(this.isInstitucija){
        this.$store.state.predmeti_report_data.naslov = `Pregled predmeta institucije ${this.represented_pers.naziv}`;
      }
      else if(this.isFizicka || this.isLegBody){
        this.$store.state.predmeti_report_data.naslov = `Pregled predmeta osobe ${this.represented_pers.ime} ${this.represented_pers.prezime}`;
      }
      else if(this.isPravna){
        this.$store.state.predmeti_report_data.naslov = `Pregled predmeta osobe ${this.represented_pers.ime}`;
      }
      this.$router.push('/predmeti-report');

    },
    setPage(pg) {
      this.curr_page = pg;
    },
    calculatePageNumber() {
      this.all_pages = [];
      var finalni_broj = this.popis_predmeta.length / this.br_redova;
      if (this.popis_predmeta.length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages.push(i);
      }
      if (this.all_pages.length != 0) {
        this.curr_page = 1;
      }
    },
    paginirajOdabrane() {
      let start_idx = 0 + this.br_redova * (this.curr_page - 1);
      let end_idx = this.br_redova * this.curr_page;

      this.finalni_arr_prikaza = this.popis_predmeta.slice(
        start_idx,
        end_idx
      );
    },

    setPageKom(pg) {
      this.curr_page_kom = pg;
    },
    calculatePageNumberKom() {
      this.all_pages_kom = [];
      console.log(this.komunikacija);
      this.all_comm = []
      for (let i = 0; i < this.komunikacija.length; i++) {
        this.all_comm.push(...this.komunikacija[i].file_list.map((el)=>({...el,predmet:this.komunikacija[i].predmet})));
      }
      console.log(this.all_comm);
      var finalni_broj = this.all_comm.length / this.br_redova_kom;
      if (this.all_comm.length % this.br_redova_kom >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages_kom.push(i);
      }
      if (this.all_pages_kom.length != 0) {
        this.curr_page_kom = 1;
      }
      console.log(this.all_pages_kom);
    },
    paginirajOdabraneKom() {
      let start_idx = 0 + this.br_redova_kom * (this.curr_page_kom - 1);
      let end_idx = this.br_redova_kom * this.curr_page_kom;

      this.finalni_arr_prikaza_kom = this.all_comm.slice(
        start_idx,
        end_idx
      );
    },

    setPageProj(pg) {
      this.curr_page_proj = pg;
    },
    calculatePageNumberProj() {
      this.all_pages_proj = [];
      var finalni_broj = this.popis_projekata.length / this.br_redova;
      if (this.popis_projekata.length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages_proj.push(i);
      }
      if (this.all_pages_proj.length != 0) {
        this.curr_page_proj = 1;
      }
    },
    paginirajOdabraneProj() {
      let start_idx = 0 + this.br_redova * (this.curr_page_proj - 1);
      let end_idx = this.br_redova * this.curr_page_proj;

      this.finalni_arr_prikaza_proj = this.popis_projekata.slice(
        start_idx,
        end_idx
      );
    },

    openFile(linkToFile) {
      window.open(linkToFile);
    },
    editOsoba() {
      this.$router.push(this.$router.history.current.path + "/edit");
    },
    switchDate(inData) {
      return moment(inData.toString()).format("L");
    },
    getCorrectName() {
      let to_return = "";
      switch (this.represented_pers.id_tip_izvora.id_tip_izvora) {
        case 1:
          to_return =
            this.represented_pers.izvor_fizicka.ime +
            " " +
            this.represented_pers.izvor_fizicka.prezime;
          break;
        case 2:
          to_return = this.represented_pers.izvor_pravna.ime;
          break;
        case 3:
          to_return =
            this.represented_pers.izvor_clan_tima.ime +
            " " +
            this.represented_pers.izvor_clan_tima.prezime;
          break;
        case 4:
          to_return = this.represented_pers.custom_ime_izvora;
          break;
        default:
          break;
      }
      return to_return;
    },
  },
  destroyed() {
    document.body.classList.remove("osobe-profil");
  },
};
</script>


<style>
</style>